import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { inr, formatDateTime } from "@/lib/format";

export default function AdminPayments() {
  const [pays, setPays] = useState([]);
  useEffect(() => { api.get("/admin/payments").then(({ data }) => setPays(data)); }, []);

  return (
    <div className="p-8">
      <h1 className="font-display text-3xl font-bold tracking-tight" data-testid="admin-payments-title">Subscription Payments</h1>
      <p className="text-slate-500 text-sm mt-1 mb-6">Tenant payments to the App Owner (mock Razorpay).</p>
      <Card className="p-0 overflow-hidden border-slate-200">
        <table className="w-full text-sm">
          <thead className="bg-slate-50 text-slate-500 text-xs uppercase tracking-wider">
            <tr>
              <th className="text-left px-4 py-3">Date</th>
              <th className="text-left px-4 py-3">Tenant</th>
              <th className="text-left px-4 py-3">Reference</th>
              <th className="text-left px-4 py-3">Status</th>
              <th className="text-right px-4 py-3">Amount</th>
            </tr>
          </thead>
          <tbody>
            {pays.length === 0 && <tr><td colSpan={5} className="text-center text-slate-400 py-8">No payments yet</td></tr>}
            {pays.map((p) => (
              <tr key={p.id} className="border-t border-slate-100" data-testid={`admin-pay-${p.id}`}>
                <td className="px-4 py-3 text-xs">{formatDateTime(p.created_at)}</td>
                <td className="px-4 py-3 font-mono text-xs">{p.tenant_id?.slice(0, 8)}</td>
                <td className="px-4 py-3 font-mono text-xs">{p.gateway_ref}</td>
                <td className="px-4 py-3"><span className="pill bg-emerald-100 text-emerald-800">{p.status}</span></td>
                <td className="px-4 py-3 text-right font-semibold">{inr(p.amount)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </Card>
    </div>
  );
}
